// Validation untuk Login, Register dan Lupa Password

export const ValForgot = async (data) => {
  const errors = [];

  if (!data) {
    errors.push({ type: "email", message: "email tidak boleh kosong" });
  } else if (
    !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
      data
    )
  ) {
    errors.push({ type: "email", message: "email tidak sesuai dengan format" });
  }

  return errors;
};

export const ValLogin = async (data) => {
  const errors = [];

  if (!data.email) {
    errors.push({ type: "email", message: "email tidak boleh kosong" });
  } else if (
    !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
      data.email
    )
  ) {
    errors.push({ type: "email", message: "email tidak sesuai dengan format" });
  }

  if (!data.password) {
    errors.push({ type: "password", message: "password tidak boleh kosong" });
  }

  return errors;
};

export const ValSignup = async (data) => {
  const errors = [];

  if (!data.email) {
    errors.push({ type: "email", message: "email tidak boleh kosong" });
  } else if (
    !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
      data.email
    )
  ) {
    errors.push({ type: "email", message: "email tidak sesuai dengan format" });
  }

  if (!data.password) {
    errors.push({ type: "password", message: "password tidak boleh kosong" });
  } else if (
    // !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~])[A-Za-z\d!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]{8,}$/.test(
    //   data.password
    // )
    !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]{8,}$/.test(
      data.password
    )
  ) {
    errors.push({
      type: "password",
      message: "Password harus huruf besar, kecil, dan minimal 8 karakter",
    });
  }

  if (!data.first_name) {
    errors.push({
      type: "first_name",
      message: "nama depan tidak boleh kosong",
    });
  } else if (!/^[A-Za-z]+$/.test(data.first_name)) {
    errors.push({
      type: "first_name",
      message: "nama depan hanya mengandung alphabet",
    });
  }

  if (data.last_name) {
    if (!/^[A-Za-z]+$/.test(data.last_name)) {
      errors.push({
        type: "last_name",
        message: "nama belakang hanya mengandung alphabet",
      });
    }
  }

  if (!data.no_hp) {
    errors.push({
      type: "no_hp",
      message: "nomor telepon tidak boleh kosong",
    });
  } else if (
    !/^[0-9]*$/.test(data.no_hp) ||
    data.no_hp.length < 11 ||
    data.no_hp.length > 13
  ) {
    errors.push({
      type: "no_hp",
      message: "nomor telepon tidak sesuai format",
    });
  }

  if (!data.no_ktp) {
    errors.push({
      type: "no_ktp",
      message: "nomor KTP tidak boleh kosong",
    });
  } else if (!/^[0-9]*$/.test(data.no_ktp) || data.no_ktp.length > 16) {
    errors.push({
      type: "no_ktp",
      message: "nomor KTP tidak sesuai format",
    });
  }

  if (!data.c_password) {
    errors.push({
      type: "c_password",
      message: "konfirmasi password tidak boleh kosong",
    });
  } else if (data.c_password !== data.password) {
    errors.push({
      type: "c_password",
      message: "konfirmasi password harus sama dengan password",
    });
  }

  return errors;
};

export const ValNext = async (data) => {
  const errors = [];

  if (!data.email) {
    errors.push({ type: "email", message: "email tidak boleh kosong" });
  } else if (
    !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
      data.email
    )
  ) {
    errors.push({ type: "email", message: "email tidak sesuai dengan format" });
  }

  if (!data.first_name) {
    errors.push({
      type: "first_name",
      message: "nama depan tidak boleh kosong",
    });
  } else if (!/^[A-Za-z]+$/.test(data.first_name)) {
    errors.push({
      type: "first_name",
      message: "nama depan hanya mengandung alphabet",
    });
  }

  if (data.last_name) {
    if (!/^[A-Za-z]+$/.test(data.last_name)) {
      errors.push({
        type: "last_name",
        message: "nama belakang hanya mengandung alphabet",
      });
    }
  }

  if (!data.no_hp) {
    errors.push({
      type: "no_hp",
      message: "nomor telepon tidak boleh kosong",
    });
  } else if (
    !/^[0-9]*$/.test(data.no_hp) ||
    data.no_hp.length < 11 ||
    data.no_hp.length > 13
  ) {
    errors.push({
      type: "no_hp",
      message: "nomor telepon tidak sesuai format",
    });
  }

  if (!data.no_ktp.length) {
    errors.push({
      type: "no_ktp",
      message: "nomor KTP tidak boleh kosong",
    });
  } else if (!/^[0-9]*$/.test(data.no_ktp) || data.no_ktp.length > 16) {
    errors.push({
      type: "no_ktp",
      message: "nomor KTP tidak sesuai format",
    });
  }

  return errors;
};
